import { Button, type ButtonProps } from '@any-ui-react/core';
import classNames from 'classnames';
import type { MouseEventHandler, ReactNode } from 'react';

import { BottomFixedArea } from './BottomFixedArea';

interface Props extends ButtonProps {
  buttonLabel?: ReactNode;
  buttonWrapper?: (children: ReactNode) => ReactNode;
  message?: { left?: ReactNode; right?: ReactNode };
  spacerSize?: number;
  wrapperClassName?: string;
  onClick: MouseEventHandler<HTMLButtonElement>;
}

export const BottomFixedSaveButton = ({ buttonWrapper, message, spacerSize, wrapperClassName, ...props }: Props) => (
  <BottomFixedArea className={wrapperClassName} spacerSize={spacerSize}>
    <div className="flex items-center justify-end gap-2">
      {message?.left}
      {buttonWrapper ? buttonWrapper(_Button(props)) : _Button(props)}
      {message?.right}
    </div>
  </BottomFixedArea>
);

const _Button = (props: Props) => (
  <Button
    {...props}
    className={classNames(props.className, { 'bg-blue-6': !props.disabled }, { 'cursor-not-allowed': props.disabled })}
    onClick={props.onClick}
  >
    {props.buttonLabel || 'Save'}
  </Button>
);
